<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-language'" :note="''" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption">{{ printLang }}</v-list-item-subtitle>
      <v-list-item-title>{{ printLevel }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading || isLoading">
            <v-icon small>fa-ellipsis-v</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="edit">
            <v-list-item-avatar>
              <v-icon small>fal fa-pencil</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>編集する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="remove">
            <v-list-item-avatar>
              <v-icon small>fal fa-trash-alt</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>削除する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>
    <UtilConfirmModal ref="confirm"></UtilConfirmModal>
  </v-list-item>
  <v-container v-else>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-select
          v-model="form.lang"
          label="言語"
          item-text="text"
          item-value="value"
          :rules="rules.lang"
          :items="getLangItems"
        />
      </v-col>
      <v-col cols="12" class="px-3">
        <v-select
          v-model="form.level"
          label="自己申告の語学レベル"
          :rules="rules.level"
          :items="getLevelItems"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import UtilConfirmModal from '@/components/modals/confirm'
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutBackgroundsLang',
  components: {
    UtilConfirmModal,
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'lang',
        status: {
          loading: false
        }
      },
      meta: {
        levels: [
          '入門', '初級', '中級（下）', '中級', '中級（上）', '上級'
        ]
      },
      form: {
        id: '',
        lang: '',
        level: ''
      },
      rules: {
        lang: [
          v => !!v || '必須項目です'
        ],
        level: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function (dt) {
      if (dt) {
        this.$set(this, 'form', {
          id: '' + (dt.id ? dt.id : ''),
          lang: dt.lang ? dt.lang : 'english',
          level: dt.level ? dt.level : ''
        })
      } else if (this.$props.data) {
        this.$set(this, 'form', {
          id: '' + (this.$props.data.id ? this.$props.data.id : ''),
          lang: this.$props.data.lang ? this.$props.data.lang : 'english',
          level: this.$props.data.level ? this.$props.data.level : ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          id: (this.$props.data && this.$props.data.id) ? ('lang_' + this.$props.data.id) : '',
          type: this.config.type
        }
      })
    },
    remove: function () {
      this.$refs.confirm.open({
        title: '語学力の削除',
        message: 'この語学力を削除してもよろしいですか？',
        callback: () => {
          this.$set(this.config.status, 'loading', true)
          this.$firebase.auth().currentUser.getIdToken(true).then(token => {
            this.axios.post(this.$url.api + 'about/delete/meta', {
              id: this.$props.data.id,
              cid: this.$route.params.id
            }, {
              headers: {
                'firebase-token': token
              }
            }).then(res => {
              console.log(res)
              if (res.data && res.data.success) {
                this.$emit('emit', {
                  action: 'remove',
                  data: {
                    type: 'langs',
                    id: res.data.data.id ? res.data.data.id : ''
                  }
                })
              }
            })
          })
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === ('lang_' + this.$props.data.id))
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === ('lang_' + this.$props.data.id)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === ('lang_' + this.$props.data.id)
      )
    },
    printLevel () {
      return (
        this.$props.data &&
        this.$props.data.level
      ) ? this.$props.data.level : '語学力'
    },
    printLang () {
      return (
        this.$props.data &&
        this.$props.data.lang &&
        this.$mango.about.langs[this.$props.data.lang]
      ) ? this.$mango.about.langs[this.$props.data.lang] : ''
    },
    isLangEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.lang
      )
    },
    getLangItems () {
      return Object.keys(this.$mango.about.langs).map(key => {
        return {
          text: this.$mango.about.langs[key],
          value: key
        }
      })
    },
    getLevelItems () {
      return this.meta.levels
    }
  }
}
</script>
